export default __webpack_public_path__ + "static/media/logo_ppp-ar_intro.7d69d5b0.png";